/** Longest search term the mention picker may send. Anything longer is a paste, not a name. */
export const MAX_MENTIONABLE_QUERY_LENGTH = 80;
/**
 * How few characters a mention search has to carry before the whole audience is scanned.
 *
 * One character is a keystroke, not a search: it matches most of a team and tells the person who
 * typed it nothing. Below this the endpoint answers with the head of the audience in name order —
 * the same first page the picker shows before anybody types — instead of a filtered scan.
 */
export const MIN_MENTIONABLE_QUERY_LENGTH = 2;
/** How many names one page of the mention picker carries, and the most it will ever carry. */
export const DEFAULT_MENTIONABLE_LIMIT = 10;
export const MAX_MENTIONABLE_LIMIT = 25;
/** The names of the websocket events this module adds. Shared so both ends spell them the same. */
export const CONVERSATION_EVENTS = {
    SUBSCRIBE: 'conversation.subscribe',
    UNSUBSCRIBE: 'conversation.unsubscribe',
    MESSAGE_NEW: 'conversation.message',
    /** A message was rewritten by its sender. Carries the message so a thread can be re-read. */
    MESSAGE_EDITED: 'conversation.message.edited',
    /** A message was withdrawn. The payload is the tombstone, with no body and no attachments. */
    MESSAGE_DELETED: 'conversation.message.deleted',
    /**
     * Somebody moved their own read cursor.
     *
     * Sent to that person's other devices and to nobody else: an unread badge that clears on the
     * phone and stays lit on the laptop is the bug this exists to prevent, and who has read what is
     * not the rest of the team's business.
     */
    READ_UPDATED: 'conversation.read',
    CALL_UPDATED: 'conversation.call',
};
//# sourceMappingURL=communication.js.map